(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-stats-strip"] && !Shopify.designMode) return;
  try {
    
  const strip = document.currentScript.closest('.fp-stats-strip') ||
    document.querySelector('.fp-stats-strip');

  if (!strip) return;

  function parseNumber(raw) {
    const match = raw.match(/[\d,]+/);
    if (!match) return { value: null, suffix: raw };
    const value = parseInt(match[0].replace(/,/g, ''), 10);
    const suffix = raw.replace(match[0], '');
    return { value, suffix };
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function countUp(el, target, suffix, duration) {
    const start = performance.now();
    function tick(now) {
      const elapsed = Math.min((now - start) / duration, 1);
      const current = Math.floor(easeOutCubic(elapsed) * target);
      el.textContent = current.toLocaleString() + suffix;
      if (elapsed < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        strip.classList.add('is-visible');

        strip.querySelectorAll('.fp-stat__number').forEach((el) => {
          const raw = el.dataset.raw || el.textContent.trim();
          const { value, suffix } = parseNumber(raw);
          if (value !== null) {
            setTimeout(() => countUp(el, value, suffix, 1800), 300);
          }
        });

        observer.disconnect();
      });
    },
    { threshold: 0.25 }
  );

  observer.observe(strip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
